import { ReactNode } from 'react';
import { motion } from 'framer-motion';
import { fadeInUp, cardHover, reducedMotionVariants, reducedCardHover } from './AnimationVariants';
import { useReducedMotion } from '@/hooks/use-reduced-motion';

interface AnimatedCardProps {
  children: ReactNode;
  className?: string;
  hoverEffect?: boolean;
}

export function AnimatedCard({ 
  children, 
  className = '',
  hoverEffect = true
}: AnimatedCardProps) {
  const prefersReducedMotion = useReducedMotion();
  
  const hoverAnimation = prefersReducedMotion ? reducedCardHover : cardHover;
  const tapAnimation = prefersReducedMotion ? undefined : { scale: 0.98 };
  
  return (
    <motion.div
      className={className}
      variants={prefersReducedMotion ? reducedMotionVariants : fadeInUp}
      whileHover={hoverEffect ? hoverAnimation : undefined}
      whileTap={hoverEffect ? tapAnimation : undefined}
    >
      {children}
    </motion.div>
  );
}

export default AnimatedCard;
